import { render, staticRenderFns } from "./MeasureCategoryCreateForm.vue?vue&type=template&id=68a6a700&"
import script from "./MeasureCategoryCreateForm.vue?vue&type=script&lang=js&"
export * from "./MeasureCategoryCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports